import { useTranslation } from 'react-i18next';
import { Typography } from 'mobily-ui-library/lib';

import Brand from '../../../assets/Brand.svg';
import CircleArrow from '../../../assets/CircleArrow.svg';

import './ProductFinance.scss';
import { useState, useContext } from 'react';
import { GlobalContext } from '../../../context/GlobalContext';

const win: any = window;
interface Props {
    rtl: boolean;
    subsidyFlag: any;
    handleAddCart: (flow: string) => void;
    instalmentFlag: any;
    preOrderInstallmentFlag: any;
}

function ProductFinance({ rtl, subsidyFlag, handleAddCart, instalmentFlag, preOrderInstallmentFlag, }: Props) {
    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);
    const { seriesId } = state;
    const isSubsidy: any = subsidyFlag ? "Yes" : "No";
    const isInstalment: any = instalmentFlag ? "Yes" : "No";
    const isPreOrderInstalment: any = preOrderInstallmentFlag ? "Yes" : "No";


    const handleCheck = (flow: any) => {
        handleAddCart(flow);
        const wcmElement: any = document.getElementById("reactWCMControlBlockID");
        if (wcmElement !== null) {
            wcmElement.style.display = 'none';
        }
    }
 
    const handlePreorderInstallment = () => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        const isArabic = rtl; 
        const productPaths: { [key: string]: string } = {
            'galaxy_z_fold7_series_da_20250707': 'galaxy_z_fold7',
            'galaxy_z_flip7_series_da_20250707': 'galaxy_z_flip7',
            'galaxy_z_fold7_fe_series_da_20250707' : 'galaxy_z_flip7fe'
        };
        const productPath = productPaths[seriesId];
        const baseUrl = `https://shop.mobily.com.sa/product/${productPath}/`;
        const url = isArabic ? baseUrl : `${baseUrl}?lang=en`;

        window.location.href = url;
    };

    return (
    <div id='device-finances' className='deviceDetails__financesContainer'>
        <Typography rtl={rtl} className='DD__FinanceTitle'>{t('Mobily_Financing')}</Typography>

        {isSubsidy === "Yes" ? (
            <div className='deviceDetails__Subsidy'>
                <div className='DD__SubsidyHead'>
                    <img src={Brand} alt='mobily-icon' />
                    <Typography rtl={rtl} className='DD__SubsidyTitle'>{t('Device_subsidy')}</Typography>
                </div>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('Get_Discount_Upto')} {t('SAR')} 7200 .</Typography>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('For_selected_plan')}<sup>3</sup></Typography>

                <Typography rtl={rtl} className='DD__SubsidyLink' onClick={() => { handleCheck('subsidy') }}>
                    {t('Check_Discount')} <img src={CircleArrow} alt='arrow' />
                </Typography>
            </div>) : (<></>)}

        {isInstalment === "Yes" ? (
            <div className='deviceDetails__Installments'>
                <div className='DD__SubsidyHead'>
                    <img src={Brand} alt='mobily-icon' />
                    <Typography rtl={rtl} className='DD__SubsidyTitle'>{t('device_installments')}</Typography>
                </div>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('split_the_cost_instalments', { upto_amount: 'X' })}</Typography>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('For_selected_plan')}<sup>4</sup></Typography>

                    <Typography rtl={rtl} className='DD__SubsidyLink' onClick={() => { handleCheck('instalment') }}>
                        {t('Check_Eligibility')} <img src={CircleArrow} alt='arrow' />
                    </Typography>
                </div>) : (<></>)}

            {isPreOrderInstalment === "Yes" ? (
                <div className='deviceDetails__Installments'>
                    <div className='DD__SubsidyHead'>
                    <img src={Brand} alt='mobily-icon' />
                    <Typography rtl={rtl} className='DD__SubsidyTitle'>{t('device_installments')}</Typography>
                </div>
                    <Typography rtl={rtl} className='DD__SubsidyContent'>{t('preOrder_installments_terms_conditions')}</Typography>
                    <Typography rtl={rtl} className='DD__SubsidyContent'>{t('For_selected_plan')}</Typography>

                    <Typography rtl={rtl} className='DD__SubsidyLink' onClick={handlePreorderInstallment}>
                        {t('Check_preOrder_installment')} <img src={CircleArrow} alt='arrow' />
                    </Typography>
                </div>) : (<></>)}


        </div>

    )
}

export default ProductFinance